import { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router";
import { useInsights } from "./Insights";
import { cx } from "./ui";

/** Every page in the Stock area, in the order of its tabs. */
export const STOCK_TABS = [
  { to: "/products", label: "Products", also: [] as string[] },
  { to: "/stock", label: "Receive stock", also: [] as string[] },
  { to: "/count", label: "Count stock", also: [] as string[] },
  { to: "/log", label: "Stock log", also: [] as string[] },
  { to: "/health", label: "Stock health", also: [] as string[] },
  { to: "/catalog", label: "Categories, brands & units", also: [] as string[] },
  { to: "/suppliers", label: "Suppliers", also: [] as string[] },
];
export const isStockPage = (path: string) => STOCK_TABS.some((t) => [t.to, ...t.also].some((p) => path === p || path.startsWith(`${p}/`)));

/** The tabs across the top of the Stock area, showing only what this person can open. */
export function StockTabs({ allowed }: { allowed: (to: string) => boolean }) {
  const path = useLocation().pathname;
  const q = useInsights("28");
  const buy = q.data?.needs.reorder ?? 0;
  const bar = useRef<HTMLElement>(null);
  // On a phone, keep the current tab in view.
  useEffect(() => {
    bar.current?.querySelector('[aria-current="page"]')?.scrollIntoView({ block: "nearest", inline: "center" });
  }, [path]);
  return (
    <nav ref={bar} aria-label="Stock" className="no-scrollbar mb-5 flex gap-0.5 overflow-x-auto border-b border-slate-200 print:hidden">
      {STOCK_TABS.filter((t) => allowed(t.to)).map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => cx("-mb-px flex h-12 flex-none items-center gap-2 whitespace-nowrap border-b-[3px] px-3.5 text-sm", isActive || t.also.includes(path) ? "border-brand font-extrabold text-ink" : "border-transparent font-semibold text-slate-500 hover:text-ink")}>
          {t.label}
          {t.to === "/health" && buy ? <span className="ui-pill min-w-5 bg-brand px-1.5 text-center text-[11px] font-extrabold leading-5 text-white">{buy}</span> : null}
        </NavLink>
      ))}
    </nav>
  );
}
